import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=0ba4833a&scoped=true"
import script from "./notice-detail.vue?vue&type=script&lang=js"
export * from "./notice-detail.vue?vue&type=script&lang=js"
import style0 from "./notice-detail.vue?vue&type=style&index=0&id=0ba4833a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4833a",
  null
  
)

export default component.exports